import React from "react";

export default function About() {
  return (
    <div className="about-page container-fluid">
      {/* 🔥 HERO */}
      <div className="about-hero">
        <h1>About Us</h1>
        <p>Your trusted platform for embroidery machines & services</p>
      </div>

      <div className="row">
        {/* 🔥 LEFT CONTENT */}
        <div className="col-lg-10">
          {/* ABOUT */}
          <div className="about-section">
            <h2>Who We Are</h2>
            <p>
              StitchMart is a one-stop platform where you can buy embroidery
              machines, rent workspace, and hire skilled designers. We aim to
              simplify the embroidery business ecosystem by connecting buyers,
              sellers, and professionals.
            </p>
          </div>

          {/* MISSION / VISION */}
          <div className="about-grid">
            <div className="about-card">
              <h4>Our Mission</h4>
              <p>
                To empower embroidery businesses by providing easy access to
                machines, workspaces, and skilled professionals.
              </p>
            </div>

            <div className="about-card">
              <h4>Our Vision</h4>
              <p>
                To become India's leading marketplace for embroidery solutions
                and services.
              </p>
            </div>
          </div>

          {/* WHY US */}
          <div className="about-section">
            <h2>Why Choose Us</h2>

            <div className="why-grid">
              <div>
                <i className="bi bi-award"></i>
                <h5>Best Quality</h5>
                <p>Trusted sellers & verified listings</p>
              </div>

              <div>
                <i className="bi bi-currency-rupee"></i>
                <h5>Affordable</h5>
                <p>Best prices in market</p>
              </div>

              <div>
                <i className="bi bi-people"></i>
                <h5>Expert Network</h5>
                <p>Skilled designers available</p>
              </div>

              <div>
                <i className="bi bi-headset"></i>
                <h5>Support</h5>
                <p>24/7 customer help</p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-lg-none mt-4">
          <div className="mobile-ads p-3 bg-white shadow-sm rounded text-center">
            <h6 className="fw-bold">Sponsored</h6>

            <div className="ad-card mt-2">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>
              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div>
        {/* 🔥 RIGHT ADS */}
        <div className="col-lg-2">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>

              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
